import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { INotesArrowData, notesData } from './notes.data';

export interface INotesData {
  name: string;
  isVisible: boolean;
  offset?: { top: number; left: number };
  position: { top: number; left: number; width: number; height: number };
  /** When true, position.left is treated as the anchor's midpoint and
   *  the host gets `transform: translateX(-50%)` so the tooltip box
   *  centres itself horizontally on the anchor regardless of width. */
  centered?: boolean;
}

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrl: './notes.component.scss',
})
export class NotesComponent implements OnInit, OnChanges {
  // No `!` here: the directive populates `data` only after a 2x rAF
  // delay, so during the initial CD pass the value really is undefined.
  // The template + getters guard for that.
  @Input() data?: INotesData;

  dismissed = false;

  constructor(
    protected hostRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(_changes: SimpleChanges): void {}

  onDataChange(data: INotesData) {
    // Reset dismissed state when tooltip becomes visible again (e.g. new tutor loaded)
    if (data.isVisible && !this.data?.isVisible) {
      this.dismissed = false;
    }
    this.data = data;
    this.updatePosition();
  }

  close() {
    this.dismissed = true;
  }

  ngOnInit() {
    this.updatePosition();
  }

  updatePosition() {
    // The directive creates this component via createComponent() and
    // populates `data` only after a 2x rAF delay so the host's
    // bounding rect is settled. ngOnInit fires before that, so `data`
    // can be undefined for one frame — bail out instead of crashing.
    const view = this.viewData;
    if (!this.data?.position || !view?.offset) return;
    const el = this.hostRef.nativeElement;
    this.renderer.setStyle(
      el,
      'top',
      this.data.position.top + view.offset.top + 'px'
    );
    this.renderer.setStyle(
      el,
      'left',
      this.data.position.left + view.offset.left + 'px'
    );
    // When `centered`, position.left was set to the anchor's midpoint —
    // shift the host left by half its own width so the tooltip box
    // centres on that point. Independent of the inner .tooltip-box
    // bounce animation (which transforms a child element).
    this.renderer.setStyle(
      el,
      'transform',
      this.data.centered ? 'translateX(-50%)' : ''
    );
  }

  get viewData(): INotesArrowData | undefined {
    if (!this.data?.name) return undefined;
    return (notesData as any)[this.data.name];
  }
}
